module.exports = __webpack_public_path__ + "static/media/booki_mobile.7541d45c.webp";